

import React, { useEffect, useState } from "react";
import { Modal, Form, DatePicker, Radio, Input, Button, message, Select } from "antd";
import axios from "axios";
import moment from "moment";
import { Option } from "antd/es/mentions";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const PreviewLeaveForm = ({ visible, onClose, approverId, fetchData }) => {
    const [form] = Form.useForm();
    const [formAudit] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [leaveMode, setLeaveMode] = useState("FULL_DAY");
    const [auditorOptions, setAuditorOptions] = useState([]);
    const [auditorId, setAuditorId] = useState(null);
    useEffect(() => {
        const fetchAuditorOptions = async () => {
            try {
                const res = await axios.get(
                    `${apiUrl}/api/auth/getAllRepresentatives`
                );
                console.log(res.data.data, "auditor options");
                setAuditorOptions(
                    res.data.data.map((auditor) => ({
                        value: auditor._id,
                        label: auditor.userName,
                    }))
                );
            } catch (err) {
                message.error("Failed to fetch auditor options");
            }
        };

        fetchAuditorOptions();
    }, []);



    const [leaveBalance, setLeaveBalance] = useState({
        sick: 0,
        casual: 0,
        compensation: 0,
    });

    const apiUrl = process.env.REACT_APP_API_URL;
    console.log(auditorOptions, "auditorId in preview leave form");
    /* ---------------- Fetch Leave Balance ---------------- */
    useEffect(() => {
        if (!auditorId) return;

        const fetchLeaveBalance = async () => {
            try {
                const res = await axios.get(
                    `${apiUrl}/api/worklogs/calculateLeaveData/${auditorId}`
                );
                console.log(res, "leave detail");
                setLeaveBalance({
                    sick: res.data.nonLOPLeavesAvailable.sick.overall,
                    casual: res.data.nonLOPLeavesAvailable.casual.overall,
                    compensation: res.data.compensation.available,
                });
            } catch {
                message.error("Failed to fetch leave balance");
            }
        };

        fetchLeaveBalance();
    }, [auditorId]);

    const noPaidLeaveLeft =
        leaveBalance.sick <= 0 && leaveBalance.casual <= 0;
    const noPaidCompLeaveLeft =
        leaveBalance.compensation <= 0;
    const handleAuditSubmit = (values) => {
        setAuditorId(values.auditorId);


    }
    /* ---------------- Submit ---------------- */
    const handleSubmit = async (values) => {
        // setAuditorId(values.auditorId);
        try {
            setLoading(true);

            const payload = {
                userId: auditorId,
                leaveMode,
                reason: values.reason,
                leaveStatus: "approved",
                isApprover: true
            };

            /* ---- Permission ---- */
            if (leaveMode === "PERMISSION") {
                payload.permissionHours = values.permissionHours;
                payload.fromDate = values.permissionDate;
                payload.toDate = values.permissionDate;
            }

            /* ---- Half / Full Day ---- */
            else {
                payload.leaveType = values.leaveType;

                if (leaveMode === "HALF_DAY") {
                    payload.fromDate = values.date;
                    payload.toDate = values.date;
                } else {
                    payload.fromDate = values.dates[0];
                    payload.toDate = values.dates[1];
                }
            }
            // console.log(payload, "request superadmin pov preview leave modal post data");
            await axios.post(
                `${apiUrl}/api/worklogs/submitLeaveRequest`,
                payload
            );

            message.success("Leave request submitted");
            form.resetFields();
            setAuditorId(null);
            fetchData?.();
            onClose();
        } catch (err) {
            message.error(err?.response?.data?.message || "Submit failed");
        } finally {
            setLoading(false);
        }
    };
    // console.log(auditorId, "auditorId outside");
    return (
        <Modal
            title="Request Leave"
            open={visible}
            onCancel={onClose && (() => {
                setAuditorId(null);
                onClose();
            })}
            footer={null}
            centered
        >
            {auditorId === null ? (<Form layout="vertical" form={formAudit} onFinish={handleAuditSubmit}>
                {/* Select Auditor */}
                <Form.Item
                    name="auditorId"
                    label="Select Auditor"
                    rules={[{ required: true }]}
                >
                    <Select
                        placeholder="Select Auditor"
                        options={auditorOptions}
                    />
                </Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                    Search
                </Button>
            </Form>) : (<Form layout="vertical" form={form} onFinish={handleSubmit}>
                {/* Leave Mode */}
                <Form.Item label="Leave Mode">
                    <Radio.Group
                        value={leaveMode}
                        onChange={(e) => {
                            setLeaveMode(e.target.value);
                            form.resetFields();
                        }}
                    >
                        <Radio.Button value="FULL_DAY">Full Day</Radio.Button>
                        <Radio.Button value="HALF_DAY">Half Day</Radio.Button>
                        <Radio.Button value="PERMISSION">Permission</Radio.Button>
                    </Radio.Group>

                </Form.Item>



                {/* FULL DAY */}
                {leaveMode === "FULL_DAY" && (
                    <Form.Item
                        name="dates"
                        label="Leave Duration"
                        rules={[{ required: true }]}
                    >
                        <RangePicker
                        // disabledDate={(d) => d && d < moment().startOf("day")}
                        />
                    </Form.Item>
                )}

                {/* HALF DAY */}
                {leaveMode === "HALF_DAY" && (
                    <Form.Item
                        name="date"
                        label="Leave Date"
                        rules={[{ required: true }]}
                    >
                        <DatePicker
                        // disabledDate={(d) => d && d < moment().startOf("day")}
                        />
                    </Form.Item>
                )}

                {/* PERMISSION DATE */}
                {leaveMode === "PERMISSION" && (
                    <Form.Item
                        name="permissionDate"
                        label="Permission Date"
                        rules={[{ required: true }]}
                    >
                        <DatePicker
                        // disabledDate={(d) => d && d < moment().startOf("day")}
                        />
                    </Form.Item>
                )}

                {/* LEAVE TYPE */}
                {leaveMode !== "PERMISSION" && (
                    <Form.Item
                        name="leaveType"
                        label="Leave Type"
                        rules={[{ required: true }]}
                    >
                        <Radio.Group>
                            {!noPaidLeaveLeft && (
                                <>
                                    <Radio
                                        value="sickLeave"
                                        disabled={leaveBalance.sick <= 0}
                                    >
                                        Sick Leave ({leaveBalance.sick})
                                    </Radio>
                                    <Radio
                                        value="casualLeave"
                                        disabled={leaveBalance.casual <= 0}
                                    >
                                        Casual Leave ({leaveBalance.casual})
                                    </Radio>

                                </>
                            )}
                            {!noPaidCompLeaveLeft && leaveMode === "FULL_DAY" && (
                                <>
                                    <Radio
                                        value="compensationLeave"
                                        disabled={leaveBalance.compensation <= 0}
                                    >
                                        Compensation Leave ({leaveBalance.compensation})
                                    </Radio>
                                </>
                            )}
                            {noPaidLeaveLeft && (
                                <Radio value="lop">Loss of Pay (LOP)</Radio>
                            )}
                        </Radio.Group>
                    </Form.Item>
                )}

                {/* PERMISSION HOURS */}
                {leaveMode === "PERMISSION" && (
                    <Form.Item
                        name="permissionHours"
                        label="Permission Hours"
                        rules={[{ required: true }]}
                    >
                        <Radio.Group>
                            <Radio value={1}>1 Hour</Radio>
                            <Radio value={2}>2 Hours</Radio>
                            <Radio value={3}>3 Hours</Radio>
                        </Radio.Group>
                    </Form.Item>
                )}

                {/* Reason */}
                <Form.Item
                    name="reason"
                    label="Reason"
                    rules={[{ required: true }]}
                >
                    <TextArea rows={3} />
                </Form.Item>

                <Button type="primary" htmlType="submit" loading={loading} block>
                    Apply Leave
                </Button>
            </Form>)}

        </Modal>
    );
};

export default PreviewLeaveForm;
